// extracted by mini-css-extract-plugin
export default {"con":"styles_con__GANsu","content":"styles_content__djA9s"};